//Function to see if the questions have changes since they were last answered. 
export function doAnswersLookeLikeTheQuestions(questions, answers)
{
	if(questions.length !== answers.length)
	{
		return false;
	}

	var returnBool = true;
	questions.forEach( (item, index) => 
	{
		switch(item.type)
		{
			case "radio":		 		
				if(! (answers[index] === ""))
				{
					var radioAnswer = parseInt(answers[index], 10);
					if(Number.isInteger(radioAnswer))
					{
						if(1 > radioAnswer || item.answers.length < radioAnswer)
						{
							returnBool = false;
							//console.log("Need to erase, radio: ", item.answers, answers[index]);
						}
					}else
					{
						returnBool = false;
						//console.log("Need to erase, radio: ", item.answers, answers[index]);
					}
				}
				break;
			case "checkbox":
				if(! (answers[index] === ""))
				{
					var answersArray = answers[index].split(",");
					answersArray.forEach(element => {
						var checkboxAnswer = parseInt(element, 10);
						if(Number.isInteger(checkboxAnswer))
						{
							if( 1 > checkboxAnswer || item.answers.length < checkboxAnswer )
							{
								returnBool = false;
								//console.log("Need to erase: checkbox: ", checkboxAnswer, item.answers.length);
							}
						}else
						{
							returnBool = false;
							//console.log("Need to erase, checkbox: ", checkboxAnswer, answers[index]);
						}
					});
				}
				break;
			case "select":
				var selectAnswersArray = answers[index].split(",");
				if(item.answers.length !== selectAnswersArray.length ) //There needs to be the same number of answers
				{
					returnBool = false;
					//console.log("Need to erase, select count mismatch:", item.answers, selectAnswersArray );
				}else
				{
					item.answers.forEach( (element, index) => {
						var selectAnswerNum = parseInt(selectAnswersArray[index], 10);
						if(! (element.length > selectAnswerNum)) 
						{
							returnBool = false;
							//console.log("Need to erase, select answers out of range: ", element.length, selectAnswerNum);
						}					
					});
				}
				break;

			case "selectParagraph":
				var selectParagraphAnswersArray = answers[index].split(",");
				if(item.answers.length !== selectParagraphAnswersArray.length ) //There needs to be the same number of answers
				{
					returnBool = false;
					//console.log("Need to erase, selectParagraph count mismatch:", item.answers, selectParagraphAnswersArray );
				}else
				{
					item.answers.forEach( (element, index) => {
						var selectAnswerNum = parseInt(selectParagraphAnswersArray[index], 10);
						if(! ((element.length - 1) > selectAnswerNum)) 
						{
							returnBool = false;
							//console.log("Need to erase, selectParagraph answers out of range: ", element.length -1, selectAnswerNum);
						}					
					});
				}
			
				break;

			default:
				break;
		}
	});

	return returnBool;
}